module.exports = __webpack_public_path__ + "static/media/ninety-nine.37af3e8b.svg";